import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	Modal
} from 'semantic-ui-react';

import { log } from '../../../../../../services/utils';

const TemplateModulePreviewModal = ( {
	onClose,
	photoUri
} ) => {
	const handleClose = useCallback( () => {
		onClose();
	}, [ onClose ] );

	return (
		<Modal
			dimmer={ false}
			onClose={ onClose }
			open={Boolean( photoUri ) }
		>
			<Modal.Header
				style={ {
					display: 'flex',
					justifyContent: 'space-between'
				} }
			>
				<span>Module Preview</span>
				<Icon
					link
					name="times"
					onClick={ handleClose }
				/>
			</Modal.Header>
			<Modal.Content
				style={ {
					maxHeight: '768px',
					overflow: 'hidden auto',
					padding: 0
				} }
			>
				{ log( '-templateModulePreviewModal' ) }
				<img
					src={ photoUri }
					style={ {
						borderRadius: 0,
						cursor: 'not-allowed',
						display: 'block',
						maxWidth: '900px'
					}}
				/>
			</Modal.Content>
		</Modal>
	);
};

TemplateModulePreviewModal.propTypes = {
	onClose: PropTypes.func.isRequired,
	photoUri: PropTypes.string.isRequired
};

export default TemplateModulePreviewModal;
